"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsWhiteListUserRequest = void 0;
var IsWhiteListUserRequest = /** @class */ (function () {
    function IsWhiteListUserRequest() {
    }
    return IsWhiteListUserRequest;
}());
exports.IsWhiteListUserRequest = IsWhiteListUserRequest;
;
//# sourceMappingURL=isWihteListUser.request.js.map